import React from 'react';
import {InputText} from "primereact/inputtext";
import {Button} from 'primereact/button';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import _ from "lodash";

const SingleValueDynamicTable = ({formik, name, title, addRowName, disabled}) => {
	const handleAddRow = () => {
		const clonedData = _.cloneDeep(formik.values);

		if(!clonedData[name])
		{
			clonedData[name] = [];
		}

		clonedData[name].push({
			value: ""
		});

		formik.setValues(clonedData);
	}

	const textEditor = (options) => {
		return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
	}

	const onCellEditComplete = (e) => {
		let { rowIndex, newRowData, originalEvent: event } = e;
		const clonedData = _.cloneDeep(formik.values);

		clonedData[name][rowIndex] = newRowData;

		formik.setValues(clonedData);
		event.preventDefault();
	}

	return (
			<div className="single-value-dynamic-table">
				<h1>{title}</h1>
				<DataTable value={formik.values[name] || []} editMode="cell" className="editable-cells-table" responsiveLayout="scroll">
					<Column field="value" header={title} body={(rowData) => rowData.value || "-"}
							editor={!disabled? (options) => textEditor(options) : undefined} onCellEditComplete={onCellEditComplete} />
				</DataTable>

				<Button type="button" label={addRowName || "Add Row"} className="p-button-text" onClick={handleAddRow} visible={!disabled}/>
			</div>

	);
}

export default SingleValueDynamicTable;
